import { render, staticRenderFns } from "./MarketingCenter.vue?vue&type=template&id=3d724867&scoped=true&"
import script from "./MarketingCenter.vue?vue&type=script&lang=js&"
export * from "./MarketingCenter.vue?vue&type=script&lang=js&"
import style0 from "./MarketingCenter.vue?vue&type=style&index=0&id=3d724867&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d724867",
  null
  
)

export default component.exports